const billReports = {
  description:
    'Proporciona una visión general de los detalles del viaje y de los pasajeros, incluyendo la logística del viaje, los estados y las métricas clave para la facturación y auditoría de los servicios de transporte.',
  actions: {
    export: 'Export',
  },

  table: {
    headers: {
      tripId: 'ID de Viaje',
      jobId: 'ID de Reservación',
      waitAndReturn: 'Esperar y Regresar',
      externalId: 'ID Externo',
      jobStatus: 'Estado de Reservación',
      actualPickupTime: 'Hora Real de Recogida',
      actualDropTime: 'Hora Real de Entrega',
      plannedPickupTime: 'Hora Planificada de Recogida',
      plannedDropTime: 'Hora Planificada de Entrega',
      canceledBy: 'Cancelado por',
      assignedBy: 'Asignado por',
      routeId: 'ID de Ruta',
      tripStatus: 'Estado del Viaje',
      isShared: 'Compartido',
      supplier: 'Proveedor',
      areas: 'Zonas',
      from: 'Desde',
      to: 'Hacia',
      date: 'Fecha',
      driver: 'Conductor',
      vehicle: 'Vehículo',
      profile: 'Perfil',
      passenger: 'Pasajero',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      attributes: 'Atributo',
      cost: 'Costo',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'New',
          onhold: 'On Hold',
          cancelled: 'Cancelled',
          routing: 'Routing',
          routed: 'Routed',
          picked: 'Picked',
          dropped: 'Dropped',
          noshow: 'Noshow',
        },
      },
    },

    filters: {
      assigned: {
        automated: 'Automated Assigned',
        manually: 'Manual Assigned',
        manuallyIntegration: 'Manually Assigned (Integration)',
        all: 'Automated & Manually Assigned',
      },
      shared: {
        onlyWithout: 'Not Shared',
        onlyWith: 'Shared',
        all: 'Shared & Not Shared',
      },

      tripStatus: 'Estados del Viaje',
      jobStatus: 'Estados de Reserva',
      vehicles: 'Vehicles',
      drivers: 'Drivers',
      suppliers: 'Proveedores',
      profiles: 'Prfiles',
      areas: 'Zonas',
      locations: 'Ubicaciones',
      airportLocations: 'Ubicaciones de Aeropuerto',
      attributes: 'Atributo',
    },
  },
  tableSummary: {
    title: 'Shuttle Reports',
    headers: {
      trips: 'Viajes',
      jobs: 'Reservación',
      vehicles: 'Vehículos',
      shared: 'Compartido',
      autoAssigned: 'Asignado Automático',
      waitAndReturn: 'Esperar y Regresar',
    },
  },
};

export default billReports;
